import { render } from "./ConfirmMailView.vue?vue&type=template&id=1dfcfaac"
import script from "./ConfirmMailView.vue?vue&type=script&lang=js"
export * from "./ConfirmMailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__